import { gql } from '@apollo/client';
import Fragments from './fragments';

export const ENGINE_SCORING_GRID_QUERY = gql`
  query engineScoringGrid($engineScoringId: Int!) {
    engineScoringGrid(engineScoringId: $engineScoringId) {
      ...engineScoringGridItem
      intervals {
        ...engineScoringGridIntervalItem
      }
      rules {
        ...engineScoringGridRuleItem
      }
      knockoutCriteria {
        ...engineScoringGridKnockoutCriteriaItem
      }
      externalSystems {
        ...engineScoringGridXExternalSystemItem
      }
      evaluatedAttributes {
        ...engineScoringXAttributeItem
        engineAttribute {
          ...engineAttributeItem
        }
      }
      partnerTypes {
        ...engineScoringXPartnerTypeItem
      }
      partnerBaseTypes {
        ...engineScoringGridXPartnerBaseTypeItem
      }
      classifications {
        ...engineScoringGridClassificationItem
        attributes {
          ...engineScoringGridClassificationXEngineAttributeItem
        }
        categories {
          ...engineScoringGridClassificationXScoringItem
        }
        financialIndicators {
          ...engineScoringGridClassificationXFinancialIndicatorItem
        }
      }
    }
  }
  ${Fragments.engineScoringGridItem}
  ${Fragments.engineScoringGridIntervalItem}
  ${Fragments.engineScoringGridRuleItem}
  ${Fragments.engineScoringGridKnockoutCriteriaItem}
  ${Fragments.engineScoringGridXExternalSystemItem}
  ${Fragments.engineScoringXAttributeItem}
  ${Fragments.engineAttributeItem}
  ${Fragments.engineScoringXPartnerTypeItem}
  ${Fragments.engineScoringGridXPartnerBaseTypeItem}
  ${Fragments.engineScoringGridClassificationItem}
  ${Fragments.engineScoringGridClassificationXEngineAttributeItem}
  ${Fragments.engineScoringGridClassificationXScoringItem}
  ${Fragments.engineScoringGridClassificationXFinancialIndicatorItem}
`;

export const SCORING_FILTER_TYPES_QUERY = gql`
  query scoringFilterTypes {
    scoringFilterTypes {
      id
      name
    }
  }
`;

export const SCORING_TARGET_CONTEXTS_QUERY = gql`
  query scoringTargetContexts {
    scoringTargetContexts {
      id
      name
    }
  }
`;

export const PERIOD_SELECTION_LIST_QUERY = gql`
  query periodSelectionList {
    periodSelectionList {
      id
      name
    }
  }
`;

export const SCORING_CATEGORIES_DICTIONARY_QUERY = gql`
  query scoringCategoriesDictionary {
    scoringCategoriesDictionary {
      scoringId
      orderNo
      code
      name
    }
  }
`;

export const DICTIONARY_APPLICATION_PAGE_QUERY = gql`
  query dictionaryApplicationPage {
    dictionaryApplicationPage {
      id
      name
    }
  }
`;

export const DICTIONARY_SCORING_RESPONSE_STATE_QUERY = gql`
  query dictionaryScoringResponseState {
    dictionaryScoringResponseState {
      id
      name
    }
  }
`;

export const DICTIONARY_KNOCKOUT_CRITERIA_QUERY = gql`
  query dictionaryKnockoutCriteria {
    dictionaryKnockoutCriteria {
      id
      name
    }
  }
`;

export const DICTIONARY_EXTERNAL_SYSTEM_INTERROGATION_QUERY = gql`
  query dictionaryExternalSystemInterrogation {
    dictionaryExternalSystemInterrogation {
      id
      name
    }
  }
`;

export const ENGINE_ATTRIBUTE_OPTIONS_QUERY = gql`
  query engineAttributeOptions {
    engineAttributeOptions {
      engineAttributeId
      orderNo
      attributeName
      description
      expression
      sensitiveInfo
      storeYN
    }
  }
`;

export const SCORING_FINANCIAL_INDICATOR_OPTIONS_QUERY = gql`
  query scoringFinancialIndicatorOptions {
    scoringFinancialIndicatorOptions {
      id
      orderNo
      code
      name
    }
  }
`;

export const DICTIONARY_SCORING_RESPONSE_COLOR_QUERY = gql`
  query dictionaryScoringResponseColor {
    dictionaryScoringResponseColor {
      id
      name
    }
  }
`;
